export default __webpack_public_path__ + "static/media/AFTIM-img-2.7f8c4600.jpg";